import * as React from "react";
import { validateCodeCompany, validateCodePerson } from "../../../../../Feature/TyelOfferForm/code/Scripts/services/companyCodeService";
import { IText } from "../../../../../Feature/TyelOfferForm/code/Scripts/models/texts";
import { ICheckResponse } from "../../../../../Feature/TyelOfferForm/code/Scripts/models/apiResponse";
import SecurityService from "@security/Services/SecurityService";
import Analytics from "../../../../../Foundation/Analytics/code/Scripts/Analytics";

type CompanySSNInputProps = {
    onChange: (value: string) => any;
    onCheck: (value: string) => any;
    texts: IText;
};

type CompanySSNInputStates = {
  errorClassName: string,
  text: string,
  lastCheckWasFor: string,
  isValid: boolean,
  errorText?: string,
  isAvailable: boolean
}


export default class CompanySSNInput extends React.Component<CompanySSNInputProps, CompanySSNInputStates> {
    private finishedCompanyIdRegEx = /^[\d]{7}-[\d]{1}$/;
    private finishedSsnRegEx = /^\d{6}[-+A-YXWVUBCDEF]\d{3}([0-9A-FHJK-NPR-Y])$/;
    private inputMaskPatternCompany = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/];
    private inputMaskPatternPerson = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /[-+Aa]/, /\d/, /\d/, /\d/,
        /[0-9]|[A-Fa-f]|[Hh]|[J-Nj-n]|[Pp]|[R-Yr-y]/];
  private inputMaskPlaceholder = "_";
  private errorTextPlaceholder = "x";

    constructor(props: CompanySSNInputProps) {
        super(props);

        this.state = {
          errorClassName : "stp-invalid-input-message stp-text normal invisible",
          text : "",
          lastCheckWasFor : "",
          isValid : false,
          errorText: "",
          isAvailable : false,
        }
    }
    private onKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key !== "Enter") {
            return;
        }
        this.onSearchButtonClick();
        event.currentTarget.blur();
    }

    private onSearchButtonClick = () => {

    }
    private IsCustomerAvailable(code : string):boolean{
      const instance = SecurityService.createAxiosInstance("/api/TyelOfferFormApi");

      instance({
        method: "GET",
        url: "GetIsCustomerAvailable?name=companyssninput&code=" + code
      }).then((response) => {
        console.log(response);
        if (!response) {
            return false;
        }
        var pageID = document.getElementById("pageID") as HTMLInputElement;
        var analytics = new Analytics();
        analytics.SendPost(window.location.href, "1", "Entering tyel offer form. Company: " + this.state.text, pageID.value);
        const asd : ICheckResponse = response.data;
        if(asd.result){
          this.setState({
            isAvailable: true,
            lastCheckWasFor: this.state.text,
          });
          this.props.onCheck(this.state.text);
          
          return true;
        }
        else {
          analytics.SendPost(window.location.href, "1", "Cannot enter tyel offer form. Company: " + this.state.text, pageID.value);
          this.setState({
            isAvailable: false,
            errorText: asd.reason
          });
          return false;
        }
    }).catch((e) => {
        console.log(e);
        return false;
    });
      return false;
    }

    private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {onChange, onCheck} = this.props;
        let errorClassName = "stp-invalid-input-message stp-text normal";

        const text = event.target.value.replace(this.inputMaskPlaceholder, "");
        this.setState({
            text,
        });

        if (text.length === this.inputMaskPatternCompany.length) {
            const isValid = validateCodeCompany(text);
            if (!isValid) {
              this.setState({
                errorClassName,
              });
              onChange("");
            } 
            else {
              if(this.IsCustomerAvailable(text) == true)
              {
                onCheck(text);
                this.setState({
                  lastCheckWasFor: text,
                  isValid,
                });
              }
              else{
                this.setState({
                  isValid: false,
                  errorClassName,
                });
              }
              
            }
        }
        else {
          if(text.length == 0){
            errorClassName = "stp-invalid-input-message stp-text normal invisible";
          }
            this.setState({
              isValid: false,
              errorClassName,
              errorText: this.props.texts.invalid,
            });
            onChange("");
          }
      }

    public render() { 
    return (
        <div className="form-group row">
          <label
            htmlFor="companyCode"
            className="col-sm-3 col-form-label text-right"
          >
          {this.props.texts.label}
          </label>
          <div className="col-sm-9">
          <input
            onKeyPress={this.onKeyPress}
            className={"search-bar stp-input stp-text normal"}
            onChange={this.handleChange}
            />
            <div className={this.state.errorClassName}>{this.state.errorText}</div>
          </div>
        </div>
      );
    }
}
